module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/menu-43f4ea5c994febb711a9cafb5545bfd9.png";